/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Contact_TitleInputs */

const he_help_contact_title = /** @type {(inputs: Help_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צור קשר עם התמיכה`)
};

const en_help_contact_title = /** @type {(inputs: Help_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Support`)
};

/**
* | output |
* | --- |
* | "Contact Support" |
*
* @param {Help_Contact_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const help_contact_title = /** @type {((inputs?: Help_Contact_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Contact_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_contact_title(inputs)
	return en_help_contact_title(inputs)
});